import { transformItem } from './transformItem';
import { IMenuGroup, IMenuItem } from '../../../components/MainMenuGroup';
import { IMenuBlockItemsSchema } from '../../../repositories/journal/entities/menu/MenuBlockItemsSchema';

/**
 * Трансформирует группу меню
 */
export const transformGroup = ({ items }: IMenuBlockItemsSchema): IMenuGroup => {
  return {
    items: items.length ? items.map(item => transformItem(item)) : ([] as IMenuItem[]),
  };
};
